import { render, staticRenderFns } from "./TenancyStandaloneWorkPermits.vue?vue&type=template&id=1958cee1&scoped=true&"
import script from "./TenancyStandaloneWorkPermits.vue?vue&type=script&lang=js&"
export * from "./TenancyStandaloneWorkPermits.vue?vue&type=script&lang=js&"
import style0 from "./TenancyStandaloneWorkPermits.vue?vue&type=style&index=0&id=1958cee1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1958cee1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1958cee1')) {
      api.createRecord('1958cee1', component.options)
    } else {
      api.reload('1958cee1', component.options)
    }
    module.hot.accept("./TenancyStandaloneWorkPermits.vue?vue&type=template&id=1958cee1&scoped=true&", function () {
      api.rerender('1958cee1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/view/TenancyStandaloneWorkPermits.vue"
export default component.exports